import { Directive, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { SubscriptionCounter } from './subscription-counter';
import { Logger } from '@infodata-group/inf-commons';

@Directive()
export class SubComponent implements OnDestroy {
  protected _subs: Subscription[] = [];

  ngOnDestroy(): void {
    this._subs.forEach((x) => {
      SubscriptionCounter.counter++;
      x.unsubscribe();
    });
    Logger.v(
      `Total subscriptions destroyed from SubComponent: ${SubscriptionCounter.counter}`,
    );
  }
}
